import { render, staticRenderFns } from "./WebinarRegistrationConfirmation.vue?vue&type=template&id=20f50507&"
import script from "./WebinarRegistrationConfirmation.vue?vue&type=script&lang=js&"
export * from "./WebinarRegistrationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports